import { MediaSourceType } from './types';
export var reduxKey = '@@MediaPopup';
export var MEDIA_POPUP_POLL_STREAM_ID = 'MEDIA_POPUP_POLL_STREAM_ID';
export var MEDIA_POPUP_STATUS_STREAM_ID = 'MEDIA_POPUP_STATUS_STREAM_ID';
export var MEDIA_POPUP_JOURNAL_STREAM_ID = 'MEDIA_POPUP_JOURNAL_STREAM_ID';
export var MEDIA_POPUP_POSTS_STREAM_ID = 'MEDIA_POPUP_POSTS_STREAM_ID';
export var MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID';
export var MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID';
export var MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP';
export var MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP';
export var MEDIA_POPUP_GALLECTION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_STREAM_GROUP';
export var MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID = 'MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID';
export var MEDIA_POPUP_TIER_STREAM_ID = 'MEDIA_POPUP_TIER_STREAM_ID';
export var MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP = 'MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP';
export var DEVIATIONS_PER_FETCH = 24;
export var GALLECTIONS_PER_FETCH = 250;
export var MAX_SELECTED_ITEMS = 24;
export var TIERS_PER_FETCH = 24;
export var DEVIATION_THUMB_HEIGHT = 120;
export var DEFAULT_MEDIASOURCE_TYPES = [
    MediaSourceType.GALLERY,
    MediaSourceType.COLLECTION,
    MediaSourceType.STASH,
    MediaSourceType.BROWSE,
];
export var DEFAULT_MEDIASOURCE_TYPES_WITH_POSTS_AND_TIERS = [
    MediaSourceType.GALLERY,
    MediaSourceType.COLLECTION,
    MediaSourceType.POSTS,
    MediaSourceType.STASH,
    MediaSourceType.TIER,
    MediaSourceType.TIER_DEVIATIONS,
    MediaSourceType.TIER_POSTS,
    MediaSourceType.BROWSE,
];
//# sourceMappingURL=constants.js.map